import {createAction} from 'redux-actions'

export const setLocale = createAction('LOCALE/SET_LOCALE')
export const changeLocale = createAction('LOCALE/CHANGE_LOCALE')
export const fetch = createAction('LOCALE/FETCH')
export const receive = createAction('LOCALE/RECEIVE')